export const MATERIAL_MOUDLE_CODE = "gdmaterial";
export const GD_DESIGN_MODULE_CODE = "gdesign";
export const PLUS_VIP_MODULE_CODE = "plus";

export enum AUTH_TYPE {
  /**个人商用授权 */
  PERSONAL = "personal",
  /**企业类型授权 */
  COMPANY = "company",
  /**高级授权 */
  COMPANY_PRO = "companyPro",
  /**学习 */
  NOAUTH = "noauth",
  /**大企业 */
  BIG_COMPANY = "bigCompany",
}

/**证书授权类型 */
export enum CERT_TYPE {
  /**个人商用授权 */
  PERSONAL = "personal",
  /**企业类型授权 */
  COMPANY = "company",
  /**NOAUTH */
  NOAUTH = "noauth",
}

export enum SOLUTION_VERSION {
  BASIC = "BASIC",
  PROFESSIONAL = "PROFESSIONAL",
  FLAGSHIP = "FLAGSHIP",
  PERSONAL_LEARNING = "PERSONAL_LEARNING",
  CORPORATE_STANDARD = "CORPORATE_STANDARD",
  CORPORATE_PRO = "CORPORATE_PRO",
  CORPORATE = "CORPORATE",
  PERSONAL = "PERSONAL",
  PERSONAL_COMMERCIAL = "PERSONAL_COMMERCIAL",
  HUA_BAN_TEMPLATE_LEARNING = "HUA_BAN_TEMPLATE_LEARNING",
  HUA_BAN_TEMPLATE_COMMERCIAL = "HUA_BAN_TEMPLATE_COMMERCIAL",
}

// FREE-团队免费版、BASIC-团队版、PROFESSIONAL-专业版、FLAGSHIP-企业版、INDIVIDUAL_FREE-个人免费版、INDIVIDUAL-基础版
export enum PRODUCT_TYPE {
  /** 团队版 */
  BASIC = "BASIC",
  /** 专业版*/
  PROFESSIONAL = "PROFESSIONAL",
  /**旗舰版 */
  FLAGSHIP = "FLAGSHIP",
  /** 个人免费版 */
  INDIVIDUAL_FREE = "INDIVIDUAL_FREE",
  /**基础版本 */
  INDIVIDUAL = "INDIVIDUAL",
  /**团队免费版 */
  FREE = "FREE",
}

/**稿定素材会员类型，用于判断授权类型 */
export const MATERIAL_VIP_VERSION: Record<
  SOLUTION_VERSION,
  {
    certType: CERT_TYPE;
    authType: AUTH_TYPE;
    /**授权类型文案 */
    authText: string;
    /**大会员下展示的授权类型文案 */
    plusAuthText?: string;
  }
> = {
  [SOLUTION_VERSION.BASIC]: {
    certType: CERT_TYPE.COMPANY,
    authType: AUTH_TYPE.COMPANY,
    authText: "中小企业标准授权",
    plusAuthText: "中小企业高级授权",
  },
  [SOLUTION_VERSION.PROFESSIONAL]: {
    certType: CERT_TYPE.COMPANY,
    authType: AUTH_TYPE.COMPANY_PRO,
    authText: "中小企业高级授权",
    plusAuthText: "中小企业高级授权",
  },
  [SOLUTION_VERSION.FLAGSHIP]: {
    certType: CERT_TYPE.COMPANY,
    authType: AUTH_TYPE.BIG_COMPANY,
    authText: "大企业定制授权",
    plusAuthText: "大型企业商用授权",
  },
  [SOLUTION_VERSION.PERSONAL_LEARNING]: {
    certType: CERT_TYPE.NOAUTH,
    authType: AUTH_TYPE.NOAUTH,
    authText: "仅供学习交流，不可商用",
  },
  [SOLUTION_VERSION.CORPORATE_STANDARD]: {
    certType: CERT_TYPE.COMPANY,
    authType: AUTH_TYPE.COMPANY,
    authText: "中小企业标准授权",
    plusAuthText: "中小企业高级授权",
  },
  [SOLUTION_VERSION.CORPORATE_PRO]: {
    certType: CERT_TYPE.COMPANY,
    authType: AUTH_TYPE.COMPANY_PRO,
    authText: "中小企业高级授权",
    plusAuthText: "中小企业高级授权",
  },
  [SOLUTION_VERSION.CORPORATE]: {
    certType: CERT_TYPE.COMPANY,
    authType: AUTH_TYPE.COMPANY,
    authText: "中小企业标准授权",
    plusAuthText: "中小企业高级授权",
  },
  [SOLUTION_VERSION.PERSONAL_COMMERCIAL]: {
    certType: CERT_TYPE.PERSONAL,
    authType: AUTH_TYPE.PERSONAL,
    authText: "个人商用授权",
    plusAuthText: "个人商用授权",
  },
  [SOLUTION_VERSION.PERSONAL]: {
    certType: CERT_TYPE.PERSONAL,
    authType: AUTH_TYPE.PERSONAL,
    authText: "个人商用授权",
    plusAuthText: "个人商用授权",
  },
  [SOLUTION_VERSION.HUA_BAN_TEMPLATE_LEARNING]: {
    certType: CERT_TYPE.NOAUTH,
    authType: AUTH_TYPE.NOAUTH,
    authText: "仅供学习交流, 不可商用（模板）",
  },
  [SOLUTION_VERSION.HUA_BAN_TEMPLATE_COMMERCIAL]: {
    certType: CERT_TYPE.PERSONAL,
    authType: AUTH_TYPE.PERSONAL,
    authText: "个人商用授权（仅模板）",
  },
};

/**稿定一体化会员版本 */
export const GD_VIP_VERSION = {
  free: {
    title: "免费版·个人",
    icon: "https://st0.dancf.com/static/02/202407010301-f1dc.svg",
    tag: "https://st0.dancf.com/static/02/202407180551-f2ce.svg",
  },
  freeTeam: {
    title: "免费版·团队",
    icon: "https://st0.dancf.com/static/02/202407010301-f1dc.svg",
    tag: "https://st0.dancf.com/static/02/202407180551-792c.svg",
  },
  basic: {
    title: "基础版",
    icon: "https://st0.dancf.com/static/02/202407010301-d2e9.svg",
    tag: "https://st0.dancf.com/static/02/202407180551-667c.svg",
  },
  basicVipPlus: {
    title: "基础版·大会员",
    icon: "https://st0.dancf.com/static/02/202407010301-7188.svg",
    tag: "https://st0.dancf.com/static/02/202407180551-71ef.svg",
  },
  team: {
    title: "团队版",
    icon: "https://st0.dancf.com/static/02/202407010301-845d.svg",
    tag: "https://st0.dancf.com/static/02/202407180551-9e1e.svg",
  },
  teamVipPlus: {
    title: "团队版·大会员",
    icon: "https://st0.dancf.com/static/02/202407010301-4811.svg",
    tag: "https://st0.dancf.com/static/02/202407180551-9e11.svg",
  },
  enterprise: {
    title: "企业版",
    icon: "https://st0.dancf.com/static/02/202407010301-f72e.svg",
    tag: "https://st0.dancf.com/static/02/202407180551-4d3d.svg",
  },
  enterpriseVipPlus: {
    title: "企业版·大会员",
    icon: "https://st0.dancf.com/static/02/202407010301-3bca.svg",
    tag: "https://st0.dancf.com/static/02/202407180551-483b.svg",
  },
} as const;

export const MATERIAL_VIP_TAG = {
  free: "",
  freeTeam: "",
  basic: "https://st0.dancf.com/static/02/202407240454-4da2.svg",
  basicVipPlus: "https://st0.dancf.com/static/02/202407240454-7a06.svg",
  team: "https://st0.dancf.com/static/02/202407240454-8b57.svg",
  teamVipPlus: "https://st0.dancf.com/static/02/202407240454-640b.svg",
  enterprise: "https://st0.dancf.com/static/02/202407240454-07f3.svg",
  enterpriseVipPlus: "https://st0.dancf.com/static/02/202407240454-122c.svg",
};

/**
 * vip 主题色映射
 */
export enum VipBgColor {
  /** 免费版 */
  Free = "var(--business-version-100-background-color-gradient, linear-gradient(270deg, #94A3C0 0%, #99A3B8 100%))",
  /** 基础版 */
  Personal = "var(--business-version-300-background-color-gradient, linear-gradient(270deg, #477BE9 0%, #5293F5 100%))",
  /** 团队版 */
  Org = "var(--business-version-400-background-color-gradient, linear-gradient(270deg, #DD9B38 0%, #E6B351 100%))",
  /** 旗舰版 */
  Flagship = "var(--business-version-500-background-color-gradient, linear-gradient(90deg, #3939A3 0%, #333397 100%))",
}

export enum EProductType {
  /** 个人免费版 */
  PersonalFree = "INDIVIDUAL_FREE",
  /** 团队免费版 */
  OrgFree = "FREE",
  /** 标准版 */
  OrgBasic = "BASIC",
  /** 专业版 */
  OrgProfessional = "PROFESSIONAL",
  /** 旗舰版 */
  OrgFlagship = "FLAGSHIP",
  /** 基础版(个人付费版) */
  Personal = "INDIVIDUAL",
  /** 基础版-个人商用授权 */
  INDIVIDUAL_PROFESSIONAL_INDIVIDUAL = "INDIVIDUAL_PROFESSIONAL_INDIVIDUAL",
  /** 基础版-企业商用授权 */
  INDIVIDUAL_PROFESSIONAL_ENTERPRISE = "INDIVIDUAL_PROFESSIONAL_ENTERPRISE",
}

export const ProductMap = {
  [EProductType.PersonalFree]: {
    color: VipBgColor.Free,
    text: "免费版·个人",
  },

  [EProductType.Personal]: {
    color: VipBgColor.Personal,
    text: "基础版",
  },

  [EProductType.OrgFree]: {
    color: VipBgColor.Free,
    text: "免费版·团队",
  },

  [EProductType.OrgBasic]: {
    color: VipBgColor.Org,
    text: "团队版",
  },

  [EProductType.OrgProfessional]: {
    color: VipBgColor.Org,
    text: "专业版",
  },

  [EProductType.OrgFlagship]: {
    color: VipBgColor.Flagship,
    text: "企业版",
  },
};
